import { FC } from "react";
import { Box, Button, TextField } from "@mui/material";
import { makeSxStyles } from "ui";
import { FormikProps } from "formik";
import { AdminPostAdminInviteReqDto } from "service/api/estabrookSchemas";

export interface AddMemberRowProps {
  memberForm: FormikProps<AdminPostAdminInviteReqDto>;
  isLoading: boolean;
  onCancel: () => void;
}

const AddMemberRow: FC<AddMemberRowProps> = ({
  memberForm,
  isLoading,
  onCancel,
}) => {
  const styles = useStyles();
  const { values, errors, touched, handleChange, handleBlur } = memberForm;

  return (
    <Box sx={styles.card} data-testid="add-member-row">
      <Box sx={styles.fields}>
        <TextField
          id="firstName"
          placeholder="Enter First Name"
          value={values.firstName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.firstName && !!errors.firstName}
          helperText={touched.firstName && errors.firstName}
          size="small"
          sx={styles.smallField}
        />
        <TextField
          id="lastName"
          placeholder="Enter Last Name"
          value={values.lastName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.lastName && !!errors.lastName}
          helperText={touched.lastName && errors.lastName}
          size="small"
          sx={styles.smallField}
        />
        <TextField
          id="email"
          placeholder="Enter Email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.email && !!errors.email}
          helperText={touched.email && errors.email}
          size="small"
          sx={styles.emailField}
        />
      </Box>
      <Box sx={styles.actions}>
        <Button
          variant="text"
          onClick={onCancel}
          data-testid="cancel-add-member"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={isLoading || !memberForm.dirty || !memberForm.isValid}
          onClick={() => memberForm.submitForm()}
          data-testid="send-invite"
        >
          Send Invite
        </Button>
      </Box>
    </Box>
  );
};

const useStyles = makeSxStyles(({ palette: { grey } }) => ({
  card: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "16px",
    width: "100%",
    border: `1px solid ${grey[400]}`,
    borderRadius: "12px",
    background: grey[600],
    padding: "12px 16px",
    boxSizing: "border-box",
  },
  fields: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    flex: "1 0 0",
  },
  smallField: {
    flex: "1 0 0",
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      marginTop: "6px",
      marginBottom: "2px",
    },
  },
  emailField: {
    flex: "2 0 0",
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      marginTop: "6px",
      marginBottom: "2px",
    },
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0,
    paddingTop: "4px",
  },
}));

export default AddMemberRow;
